import { Card } from "@circleco/compass/components/Card";
import { Icon } from "@circleco/compass/components/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface DisabledNoticeV4Props {
  onUndo: () => void;
}

const LOCALE_ROOT = "post.conversation_summary";

export const DisabledNoticeV4 = ({ onUndo }: DisabledNoticeV4Props) => (
  <Card.Root>
    <Card.Body className="p-4">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5">
          <Icon name="sparkle-filled" size="sm" color="secondary" />
          <Typography variant="label-sm" color="secondary">
            {t([LOCALE_ROOT, "disabled_notice"])}
          </Typography>
        </div>
        <IconButton
          icon="arrow-undo"
          size="sm"
          variant="ghost"
          aria-label={t([LOCALE_ROOT, "actions", "undo"])}
          onClick={onUndo}
        />
      </div>
    </Card.Body>
  </Card.Root>
);
